import { combineReducers } from 'redux'
import { reducer as account } from './account'
import { reducer as agency } from './agency'
import { reducer as
    staticValues } from './static'
import { reducer as property } from './property'
import { reducer as admin } from './admin'

const rootReducer = combineReducers({
  account,
  agency,
  staticValues,
  property,
  admin,
})

export default rootReducer
